<template>
    <div>
        <el-select v-model="temp" clearable filterable placeholder="选择分部工程" v-if="dwgc=='室外设施'">
            <el-option :value="item" v-for="(item,index) in fbgcs1" :key="index"></el-option>
        </el-select>
        <el-select v-model="temp" clearable filterable placeholder="选择分部工程" v-else-if="dwgc=='附属建筑及室外环境'">
            <el-option :value="item" v-for="(item,index) in fbgcs2" :key="index"></el-option>
        </el-select>
        <el-select v-model="temp" clearable filterable placeholder="选择分部工程" v-else>
            <el-option :value="item.title" v-for="(item,index) in fbgcs0" :key="index"></el-option>
        </el-select>
        <p class="tips" v-if="is_tip">内容务必于台账分部工程一致</p>
    </div>
</template>
<script>
    export default {
        props: {
            value: {},
            dwgc: {},
            is_tip: {
                default: true
            }
        },
        data() {
            return {
                temp: '',
                fbgcs0: [],
                fbgcs1: [
                    '路基',
                    '基层',
                    '面层',
                    '广场与停车场',
                    '人行道',
                    '人形地道',
                    '挡土墙',
                    '附属构筑物',
                    '土石方',
                    '挡土墙',
                    '支护',
                ],
                fbgcs2: [
                    '车棚',
                    '围墙',
                    '大门',
                    '挡土墙',
                    '建筑小品',
                    '亭台',
                    '水景',
                    '连廊',
                    '花坛',
                    '场坪绿化',
                    '景观桥',
                ],
            }
        },
        watch: {
            temp(val) {
                this.$emit('input', val);
            },
            value(val) {
                this.temp = val;
            }
        },
        created() {
            this._fbs();
        },
        methods: {
            _fbs() {
                this.$http.post('cate/list', {
                    pid: 0,
                    limit: 5000
                }).then(res => {
                    this.fbgcs0 = res.data.data;
                })
            }
        }
    }
</script>
<style lang="scss" scoped>
    @import "index.scss";
</style>